const rewardsBalanceUrl = "/v1/credit/accounts/rewards/balance";
export {
  rewardsBalanceUrl
};
//# sourceMappingURL=endpoints.js.map
